import {CONTRIBUTORS} from 'data/CONTRIBUTORS'

export const changelog = [
	// {
	// 	date: new Date('2021-11-19'),
	// 	Changes: () => <>The changes you made</>,
	// 	contributors: [CONTRIBUTORS.YOU],
	// },
	{
		date: new Date('2024-07-21'),
		Changes: () => <>Add rudimentary support for 7.0 and 7.01 Paladin</>,
		contributors: [
			CONTRIBUTORS.CHRIS,
		],
	},
]
